import {DocumentPropertyKey} from "../../libs/enum/document-property-key.enum";

export class DocumentPropertyDto {

  public readonly key!: DocumentPropertyKey;
  public value: string | undefined; // HTML

  constructor(init?: Partial<DocumentPropertyDto> | undefined) {
    Object.assign(this, init);
  }

  public static of(key: DocumentPropertyKey | string, value: string): DocumentPropertyDto {
    const k: DocumentPropertyKey = typeof key === 'string' ? DocumentPropertyKey[key as keyof typeof DocumentPropertyKey] : key;
    return new DocumentPropertyDto({key: k, value});
  }
}
